var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.title-1'
      )))]),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(
          'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.title-1-1'
        )))])]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.info-1-1'
        )
      )}}),_c('br'),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(
          'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.title-1-2'
        )))])]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.info-1-2'
        )
      )}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }